import React, { useEffect, useState } from "react";
import "./Topratedcompanies.css";
import shopifyImg from "../../assets/images/shopify.png";
import googleImg from "../../assets/images/google.png";
import oracleImg from "../../assets/images/oracle.png";
import pinterestImg from "../../assets/images/pintrest.png";
import axios from "axios";
import { Link } from "react-router-dom";
import { getApiBaseUrl } from "../../apiBaseUrlFinder";

const Topratedcompanies = () => {
  const [companies, setCompanies] = useState([]);

  useEffect(() => {
    axios
      .get(`${getApiBaseUrl()}/top_companies`)
      .then((response) => {
        setCompanies(response.data);
      })
      .catch((error) => {
        console.error("Error fetching companies:", error);
      });
  }, []);

  return (
    <div className="px-lg-2 px-md-2 px-2">
      {/* Inline micro-interactions for company link/logo/name */}
      <style>{`
        .company-link-cta{
          display:flex; align-items:center; gap:.5rem;
          text-decoration:none; color:inherit; cursor:pointer;
          transition: transform .12s ease;
          will-change: transform;
        }
        .company-link-cta:hover{ transform: translateY(-1px); }
        .company-link-cta:active{ transform: translateY(0) scale(.98); }
        .company-link-cta:focus-visible{
          outline:2px solid #111; outline-offset:2px; border-radius:8px;
        }

        .company-link-cta .company-logo{
          transition: transform .15s ease, box-shadow .2s ease, filter .15s ease;
          border-radius:8px;
        }
        .company-link-cta:hover .company-logo{
          transform: scale(1.04);
          box-shadow: 0 6px 16px rgba(0,0,0,.12);
        }
        .company-link-cta:active .company-logo{
          transform: scale(.98);
          box-shadow: 0 3px 10px rgba(0,0,0,.10);
        }

        .company-link-cta .company-name-btn{
          font-weight:600; /* bold */
          text-decoration: underline;
          text-underline-offset: 2px;
          text-decoration-thickness: 1px;
          transition: color .15s ease, text-decoration-thickness .12s ease, transform .12s ease;
        }
        .company-link-cta:hover .company-name-btn{
          color:#111;
          text-decoration-thickness: 2px;
          transform: translateY(-1px);
        }
        .company-link-cta:active .company-name-btn{
          transform: translateY(0) scale(.98);
        }

        @media (prefers-reduced-motion: reduce){
          .company-link-cta,
          .company-link-cta .company-logo,
          .company-link-cta .company-name-btn { transition:none; }
        }
      `}</style>

      <div className="container ">
        <div className="row pt-lg-5 pt-md-4 pt-3">
          <div className="col-12">
            <div className="text-center">
              <h3 className="top_rated_companies_h3">
                Top-Rated Companies for Managerial Excellence
              </h3>
            </div>
          </div>
        </div>

        <div className="row mb-4">
          <div className="table-responsive pt-lg-4 ptmd-4 pt-3">
            <div className="table-rounded-wrapper">
              <table className="table">
                <thead>
                  <tr className="">
                    <th>Rank</th>
                    <th>Company</th>
                    <th>
                      Rating <br />{" "}
                      <span className="out_of_five_p">Out of 5</span>
                    </th>
                    <th># of Reviews</th>
                    <th>Popular Tags</th>
                  </tr>
                </thead>
                <tbody>
                  {companies?.map((company, index) => (
                    <tr
                      key={index}
                      style={{
                        backgroundColor: "white",
                        borderBottom: "1px solid #CBCBCBA8",
                      }}
                    >
                      <td>
                        <span className="company_rank_text">
                          {company.company_rank}
                        </span>
                      </td>
                      <td style={{ textAlign: "left" }}>
                        <Link
                          to={`/company-profile?name=${encodeURIComponent(
                            company.company_name
                          )}&id=${company.company_id}`}
                          className="company-link-cta"
                          style={{ color: "inherit" }}
                          aria-label={`Open ${company.company_name} profile`}
                        >
                          {company.company_logo_url ? (
                            <img
                              src={company.company_logo_url}
                              alt={company.company_name}
                              className="company-logo me-2"
                              style={{ width: 50, height: 50, objectFit: "cover" }}
                            />
                          ) : (
                            <span>No Logo</span>
                          )}
                          {/* keep your original class, add animated class */}
                          <span className="company_rating_name company-name-btn">
                            {company.company_name}
                          </span>
                        </Link>
                      </td>
                      <td>
                        <span className="company_rating">
                          {company.company_rating}
                        </span>
                      </td>
                      <td>
                        <span className="company_rating">
                          {/*{company.all_review_count.toLocaleString()}*/}
                          {(company.all_review_count ?? 0).toLocaleString()}
                        </span>
                      </td>
                      <td>
                        {company.popular_tags.length > 0 ? (
                          company.popular_tags.map((tag, idx) => (
                            <span key={idx} className="tag me-2">
                              {tag}
                            </span>
                          ))
                        ) : (
                          <span>None</span>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Topratedcompanies;